import type { MatchConditions } from '@casl/ability';
import type {
    FilterableSubjectKey,
    SubjectConditions,
    SubjectKey,
    SubjectKeyWithCondition,
    SubjectObject,
} from '../../types/acl-types.ts';

type MatcherFn<K extends SubjectKey> = (
    conditions: SubjectConditions<K>,
    object: SubjectObject<K>,
) => boolean;

type ConditionsMatcherMap = {
    [TKey in Exclude<
        SubjectObject['kind'] & SubjectKeyWithCondition,
        `${FilterableSubjectKey}Filter`
    >]: MatcherFn<TKey>;
};

const conditionsMatchers = {
    Task: ({ assignedByIds, assignedToIds }, { assignedById, assignedToId }) => {
        if (assignedToIds?.length && (!assignedToId || !assignedToIds.includes(assignedToId))) {
            return false;
        }

        if (assignedByIds?.length && (!assignedById || !assignedByIds.includes(assignedById))) {
            return false;
        }

        return true;
    },
    Customer: ({ salesRepIds }, { rep_id }) => {
        if (salesRepIds?.length && !salesRepIds.includes(rep_id)) {
            return false;
        }

        return true;
    },
    SalesReport: () => {
        throw new Error('Not implemented');
    },
    QuoteOrder: ({ salesRepIds }, { sales_reps }) => {
        if (salesRepIds?.length && !sales_reps.some((rep) => salesRepIds.includes(rep.id))) {
            return false;
        }

        return true;
    },
    Stats: () => {
        throw new Error('Not implemented');
    },
    SalesDraft: () => {
        throw new Error('Not implemented');
    },
} satisfies ConditionsMatcherMap;

// TODO: this should have better types
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
export function conditionsMatcher(conditions: SubjectConditions) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    return (<K extends keyof ConditionsMatcherMap>(object: SubjectObject<K>) =>
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-type-assertion
        conditionsMatchers[object.kind](conditions as any, object as any)) as MatchConditions<
        Record<PropertyKey, any>
    >;
}
